import { UserAgentApplication } from 'msal';

const APP_NAME = process.env.REACT_APP_APP_NAME;
const TENANT_HOST = process.env.REACT_APP_B2C_TENANT_HOST;
const TENANT_SEGMENT = process.env.REACT_APP_B2C_TENANT_SEGMENT;
const SCOPE = process.env.REACT_APP_B2C_SCOPE;
const CLIENT_ID = process.env.REACT_APP_B2C_CLIENT_ID;
const REDIRECT_URI = process.env.REACT_APP_APP_URI;
const SECURE_URL = process.env.REACT_APP_SECURE_URL;
const POLICY_SIGNUP_SIGNIN = 'b2c_1a_signup_signin';
const POLICY_PASSWORD_RESET = 'b2c_1a_passwordreset';

export const ERR_USER_CANCELED = 'AADB2C90091';
export const ERR_FORGOT_PASSWORD = 'AADB2C90118';
export const parseError = error => {
    const match = error.errorMessage.match(/AADB2C[0-9]+/);
    return match ? match[0] : null;
};

export const inFrame = () => {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};

export const requiresInteraction = errorMessage => {
    if (!errorMessage || !errorMessage.length) {
        return false;
    }

    return (
        errorMessage.indexOf('consent_required') > -1 ||
        errorMessage.indexOf('interaction_required') > -1 ||
        errorMessage.indexOf('login_required') > -1
    );
};

export const AUTH_REQUESTS = {
    LOGIN: {
        scopes: [SCOPE],
        extraQueryParameters: {
            applicationName: APP_NAME
        }
    },
    TOKEN: (er_aid, er_uid) => ({
        scopes: [SCOPE],
        extraQueryParameters: {
            er_aid,
            er_uid,
            applicationName: APP_NAME
        }
    })
};

export const returningFromLoginRedirect = !inFrame() && window.location.hash;

export const buildAuthority = policy => `https://${TENANT_HOST}/${TENANT_SEGMENT}/${policy}`;

export const buildForgotPasswordAuthority = () => buildAuthority(POLICY_PASSWORD_RESET);

export const getPolicyFromIdpCode = code =>
    fetch(`https://${SECURE_URL}/.well-known/policy?code=${code}`)
        .then(res => {
            if (res.status === 200) {
                return res.json();
            } else {
                throw res;
            }
        })
        .then(({ policy }) => policy);

export const msal = new UserAgentApplication({
    auth: {
        clientId: CLIENT_ID,
        authority: buildAuthority(POLICY_SIGNUP_SIGNIN),
        validateAuthority: false,
        redirectUri: REDIRECT_URI,
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: true
    },
    system: {
        navigateFrameWait: 0
    }
});



// WEBPACK FOOTER //
// ./src/lib/auth.js